<template>
  <div class="page">
    <a-form-model :model="duxu" :rules="duxuRules">
      <a-form-model-item label="max_depth" prop="duxu" ref="duxu">
        <a-input v-model="duxu['duxu']"/>
      </a-form-model-item>
    </a-form-model>
    <a-form-model :model="loginForm" :rules="loginRules">
      <a-form-model-item label="邮箱" prop="email">
        <a-input v-model="loginForm.email" />
      </a-form-model-item>
      <a-form-model-item label="密码" prop="password">
        <a-input v-model="loginForm.password" type="password" />
      </a-form-model-item>
    </a-form-model>
  </div>
</template>
<script>
export default {
  data() {
    return {
      duxu: { duxu: '' },
      duxuRules: {
        duxu: [{ required: true, message: '请输入邮箱', trigger: 'blur' }]
      },
      labelCol: { span: 5 },
      wrapperCol: { span: 18 },
      loginForm: { email: '', password: '' },
      loginRules: {
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur', min: 3 }
        ],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    }
  }
}
</script>
<style lang="less" scope>
</style>
